<!-- DESKTOP -->
<div class="desktop edp-card-widget card">
    <div class="card-header">
        <span class="card-title">{{ 'pt.edp.edponline.widget.benefits.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-Bop-086"  aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-body">
        <span class="icon">
            <i class="icon-edponline-Bra-144"  aria-hidden="true"></i>
        </span>
        <div class="saving">
            <span class="saving-title">
                {{ 'pt.edp.edponline.widget.savings.text' | translate }}
            </span>
            <span class="d-inline-block saving-value">{{ value }}€</span>
        </div>
        <span class="saving-date">
            {{ 'pt.edp.edponline.widget.savings.date.inicial' | translate }} {{ discounts.firstDiscountDate |  date: 'd MMMM, y'}}
        </span>
        <span class="description">{{ 'pt.edp.edponline.widget.savings.description' | translate }}</span>
    </div>
</div>



<!-- MOBILE -->
<div class="mobile edp-card-widget card">
    <div class="card-header">
        <span class="card-title-small">{{ 'pt.edp.edponline.widget.benefits.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-Bop-086"  aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-body">
        <div class="saving-mobile">
            <span class="description-mobile">
                {{ 'pt.edp.edponline.widget.savings.text' | translate }}
                <span class="value">
                    {{ value }}€
                </span>
                {{ 'pt.edp.edponline.widget.savings.description.mobile' | translate }}
            </span>
            <span class="saving-date">
                {{ 'pt.edp.edponline.widget.savings.date.inicial' | translate }} {{ discounts.firstDiscountDate |  date: 'd MMMM, y'}}
            </span>
        </div>
    </div>
</div>

